import { createContext } from 'react';

export const validateFieldPathContext = createContext(true);
